import React, { useEffect, useState, useRef } from "react";
import Button from "../customComponents/Button";
import Table from "../customComponents/Table";
import DatePicker from "../customComponents/DatePicker";
import FilterSelect from "../customComponents/FilterSelect";
import HotelModal from "../customComponents/HotelModal";
import { createColumnHelper } from "@tanstack/react-table";
import SearchSelect from "../customComponents/SerachSelect";
import { useNavigate, useSearchParams } from "react-router-dom";
import { post } from "../utils/api";
import { ToastContainer, toast } from "react-toastify";
import ConfirmationModal from "../customComponents/ConfirmationModal";
import LoaderComponent from "./LoaderComponent";

const Hotels = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  // All filter + pagination state lives in the URL
  const currentPage = parseInt(searchParams.get("page") || "1", 10);
  const searchText = searchParams.get("search") || "";
  const cityFilter = searchParams.get("city") || "";
  const hotelFilter = searchParams.get("hoteltype") || "";

  const updateParams = (updates) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      Object.entries(updates).forEach(([k, v]) => {
        if (v) next.set(k, v);
        else next.delete(k);
      });
      return next;
    });
  };

  const [localSearch, setLocalSearch] = useState(searchText);
  const searchTimerRef = useRef(null);

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [optionsLoaded, setOptionsLoaded] = useState(false);
  const [hotelOptions, setHotelOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [isDeleteModal, setDeleteModal] = useState(false);
  const [deleteItem, setDeleteItem] = useState("");
  const [noOfPages, setNoOfPages] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    fetchData();
  }, [currentPage, searchText, cityFilter, hotelFilter]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const data = {
        page: currentPage,
        limit: 10,
        search: searchText.trim(),
        city: cityFilter,
        hoteltype: hotelFilter,
      };
      const result = await post("/getAllHotel", data);
      const temp = result.data.map((list) => ({
        hotelName: list.hotelname,
        roomType: list.hoteltype,
        city: list.city,
        accommodation: list?.hotelwise_plan?.[0]?.accommodationType?.label || 'NA',
        price: `₹ ${list?.hotelwise_plan?.[0]?.pricePerHead || 'NA'}`,
        alterCreatedon: new Date(list.createdon)
          .toLocaleDateString("en-GB")
          .replace(/\//g, "-"),
        ...list,
      }));
      setNoOfPages(result?.pagination?.total);
      setTableData(temp);

      // Populate filter dropdowns only on unfiltered load so options stay stable
      if (!optionsLoaded) {
        const citySet = new Set(result.data.map((item) => item.city));
        const hotelSet = new Set(result.data.map((item) => item.hoteltype));
        setCityOptions([
          { label: "All City", value: "All City" },
          ...Array.from(citySet).filter(Boolean).map((c) => ({ label: c, value: c })),
        ]);
        setHotelOptions([
          { label: "All Property", value: "All Property" },
          ...Array.from(hotelSet).filter(Boolean).map((h) => ({ label: h, value: h })),
        ]);
        setOptionsLoaded(true);
      }

      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching hotels:", error);
      setIsLoading(false);
    }
  };
  const handleClick = () => {
    navigate("/add-hotel");
  };
  const handleDateChange = (filterDate) => {
    // setSelectedDate(date);

    const date = new Date(filterDate);
    const day = String(date.getDate()).padStart(2, '0'); // Ensure two digits
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const year = date.getFullYear();

    const formattedDate = `${day}-${month}-${year}`;
    console.log(formattedDate);
    setFormattedDate(formattedDate)
    setSelectedDate(filterDate);

  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setLocalSearch(value);
    clearTimeout(searchTimerRef.current);
    searchTimerRef.current = setTimeout(() => {
      updateParams({ search: value || null, page: null });
    }, 400);
  };

  const columnHelper = createColumnHelper();
  const columns = [
    columnHelper.accessor("slNo", {
      header: "Sl. No",
      cell: (info) => info.row.index + 1,
    }),
    columnHelper.accessor("hotelName", {
      header: "PROPERTY NAME",
    }),
    columnHelper.accessor("roomType", {
      header: "PROPERTY TYPE",
    }),
    columnHelper.accessor("city", {
      header: "CITY",
    }),
    columnHelper.accessor("price", {
      header: "PRICE PER HEAD",
    }),
    columnHelper.accessor("actions", {
      header: "ACTIONS",
      cell: (info) => (
        <div className="flex gap-2">
          {(user?.role === "Admin" || user?.role === "Backend Team Manager") && (
            <button
              onClick={() =>
                navigate("/add-hotel", {
                  state: {
                    hotelinfo: info.row.original,
                    type: "edit",
                    editflag: true,
                  },
                })
              }
              className="p-2 bg-gray-200 rounded-md"
            >
              <span className="material-symbols-outlined">edit</span>
            </button>
          )}
          <button
            className="p-2 bg-gray-200 rounded-md"
            onClick={() => handleViewClick(info.row.original)}
          >
            <span className="material-symbols-outlined">visibility</span>
          </button>
          {(user?.role === "Admin" || user?.role === "Backend Team Manager") && (
            <button
              onClick={() => handleDeleteClick(info.row.original)}
              className="p-2 bg-gray-200 text-red-500 rounded-md"
            >
              <span className="material-symbols-outlined">delete</span>
            </button>
          )}
        </div>
      ),
    }),
  ];

  const data = [
    {
      hotelName: "Kodai_2020",
      roomType: "3 Star",
      city: "Bengaluru",
      accommodation: "Double",
      price: "₹ 4500",
    },
    {
      hotelName: "Kodai_2020",
      roomType: "3 Star",
      city: "Bengaluru",
      accommodation: "Double",
      price: "₹ 4500",
    },
    {
      hotelName: "Kodai_2020",
      roomType: "3 Star",
      city: "Bengaluru",
      accommodation: "Double",
      price: "₹ 4500",
    },
    {
      hotelName: "Kodai_2020",
      roomType: "3 Star",
      city: "Bengaluru",
      accommodation: "Double",
      price: "₹ 4500",
    },
    {
      hotelName: "Kodai_2020",
      roomType: "3 Star",
      city: "Bengaluru",
      accommodation: "Double",
      price: "₹ 4500",
    },
    {
      hotelName: "Kodai_2020",
      roomType: "3 Star",
      city: "Bengaluru",
      accommodation: "Double",
      price: "₹ 4500",
    },
    {
      hotelName: "Kodai_2020",
      roomType: "3 Star",
      city: "Bengaluru",
      accommodation: "Double",
      price: "₹ 4500",
    },
    {
      hotelName: "Kodai_2020",
      roomType: "3 Star",
      city: "Bengaluru",
      accommodation: "Double",
      price: "₹ 4500",
    },
    {
      hotelName: "Kodai_2020",
      roomType: "3 Star",
      city: "Bengaluru",
      accommodation: "Double",
      price: "₹ 4500",
    },
  ];

  const handleViewClick = (hotel) => {
    setSelectedHotel(hotel);
    setIsModalOpen(true);
  };
  const handleDeleteClick = async (data) => {
    setDeleteModal(true);
    setDeleteItem(data);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedHotel(null);
  };

  const handleFormSelection = (e, type) => {
    if (type === "hotel") {
      updateParams({ hoteltype: e.value !== "All Property" ? e.value : null, page: null });
    } else {
      updateParams({ city: e.value !== "All City" ? e.value : null, page: null });
    }
  };
  const handleConfirmDelete = async () => {
    try {
      const result = await post("/deleteHotel", deleteItem);
      toast.success("Property deleted successfully");
      setDeleteModal(false);
      fetchData();
    } catch (error) {
      toast.error("Property delete failed");
      setDeleteModal(false);
    }
  };
  const handleCloseModal = async () => {
    setDeleteModal(false);
  };

  return (
    <div>
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-primary-black text-[28px] font-semibold">
            Properties
          </h2>
          <p className="text-[14px]">
            <span className="font-bold">Properties</span> /{" "}
            <span className="font-regular">Properties List</span>
          </p>
        </div>
        <Button
          type="primary"
          label="Add Property"
          onClick={() => navigate("/add-hotel")}
        />
      </div>

      {/* Filter Fields */}
<div className="grid grid-cols-1 gap-4 mt-4 md:grid-cols-2 lg:flex lg:justify-between lg:items-center lg:gap-4">
  {/* Search Input */}
  <div className="w-full md:w-full lg:flex-[2]">
    <input
      type="text"
      className="outline-none p-2 rounded-l-lg w-full h-[40px]"
      placeholder="Search..."
      value={localSearch}
      onChange={handleSearch}
    />
  </div>

  {/* Property Type Select */}
  <div className="w-full md:w-full lg:flex-1">
    <SearchSelect
      className="w-full"
      placeholder="Property Type"
      value={hotelOptions.find((o) => o.value === hotelFilter) || null}
      onChange={(e) => handleFormSelection(e, "hotel")}
      options={hotelOptions}
    />
  </div>

  {/* City Select */}
  <div className="w-full md:w-full lg:flex-1">
    <SearchSelect
      className="w-full"
      placeholder="City"
      value={cityOptions.find((o) => o.value === cityFilter) || null}
      options={cityOptions}
      onChange={(e) => handleFormSelection(e, "city")}
    />
  </div>

  {/* Date Picker */}
  <div className="w-full md:w-full lg:flex-1">
    <DatePicker
      selectedDate={selectedDate}
      onDateChange={(date) => handleDateChange(date, "dateoftravel")}
      placeholderText="Select Date..."
      className="w-full"
    />
  </div>
</div>


      <div className="bg-white rounded-xl border-gray-300 mt-7 pb-6">
        {isLoading ? (
          <LoaderComponent />
        )
          :
          <Table
            columns={columns}
            data={tableData}
            noOfPages={noOfPages}
            currentPage={currentPage}
            setCurrentPage={(page) => updateParams({ page: page > 1 ? String(page) : null })}
          />
        }
      </div>
      <ConfirmationModal
        isOpen={isDeleteModal}
        onClose={handleCloseModal}
        onConfirm={handleConfirmDelete}
        title="Delete Hotel"
        message={`Are you sure you want to delete the hotel "${deleteItem?.hotelname}"?`}
      />

      {/* Hotel Details Modal */}
      {isModalOpen && (
        <HotelModal
          isOpen={isModalOpen}
          onClose={closeModal}
          hotelData={{
            ...selectedHotel,
            seasonDisplay:
              selectedHotel.seasonstart && selectedHotel.seasonend
                ? `${new Date(selectedHotel.seasonstart).toLocaleDateString(
                  "en-US",
                  {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  }
                )} - ${new Date(selectedHotel.seasonend).toLocaleDateString(
                  "en-US",
                  {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  }
                )}`
                : "No Season",
          }}
        />
      )}
      <ToastContainer />
    </div>
  );
};

export default Hotels;
